import { render, staticRenderFns } from "./main-setting.vue?vue&type=template&id=53e6b9d1"
import script from "./main-setting.vue?vue&type=script&lang=js"
export * from "./main-setting.vue?vue&type=script&lang=js"
import style0 from "./main-setting.vue?vue&type=style&index=0&id=53e6b9d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports